const initializeMahjCoveShare = (scope = document) => {
  scope.querySelectorAll('[data-mahjcove-share]').forEach((root) => {
    if (root.dataset.mahjcoveShareBound) return;
    root.dataset.mahjcoveShareBound = 'true';

    const shareData = {
      title: root.dataset.shareTitle || document.title,
      text: root.dataset.shareText || '',
      url: root.dataset.shareUrl || window.location.href,
    };
    const encodedUrl = encodeURIComponent(shareData.url);
    const encodedTitle = encodeURIComponent(shareData.title);
    const encodedText = encodeURIComponent(shareData.text);
    const facebook = root.querySelector('[data-mahjcove-share-network="facebook"]');
    const x = root.querySelector('[data-mahjcove-share-network="x"]');
    const pinterest = root.querySelector('[data-mahjcove-share-network="pinterest"]');
    const whatsapp = root.querySelector('[data-mahjcove-share-network="whatsapp"]');
    const nativeButton = root.querySelector('[data-mahjcove-share-native]');
    const copyButton = root.querySelector('[data-mahjcove-share-copy]');

    if (facebook) facebook.href = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
    if (x) x.href = `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`;
    if (pinterest) {
      const image = root.dataset.shareImage;
      const description = encodeURIComponent(`${shareData.title}${shareData.text ? ` — ${shareData.text}` : ''}`);
      pinterest.href = `https://www.pinterest.com/pin/create/button/?url=${encodedUrl}&media=${encodeURIComponent(image)}&description=${description || encodedText}`;
    }
    if (whatsapp) {
      const message = `${shareData.title}${shareData.text ? `\n${shareData.text}` : ''}\n${shareData.url}`;
      whatsapp.href = `https://wa.me/?text=${encodeURIComponent(message)}`;
    }

    nativeButton?.addEventListener('click', async () => {
      if (!navigator.share) return;
      try { await navigator.share(shareData); } catch (error) {
        if (error.name !== 'AbortError') console.warn('Share failed:', error);
      }
    });

    copyButton?.addEventListener('click', async (event) => {
      try {
        await navigator.clipboard.writeText(shareData.url);
      } catch (error) {
        const fallback = document.createElement('textarea');
        fallback.value = shareData.url;
        fallback.setAttribute('readonly', '');
        fallback.style.position = 'fixed';
        fallback.style.opacity = '0';
        document.body.appendChild(fallback);
        fallback.select();
        try { if (!document.execCommand('copy')) throw error; } finally { fallback.remove(); }
      }

      copyButton.setAttribute('aria-label', 'Copied');
      window.setTimeout(() => copyButton.setAttribute('aria-label', 'Copy link'), 800);
      document.querySelector('.mahjcove-article-share__toast')?.remove();
      const toast = document.createElement('span');
      toast.className = 'mahjcove-article-share__toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.textContent = 'Copied';
      document.body.appendChild(toast);
      const bounds = toast.getBoundingClientRect();
      toast.style.left = `${Math.max(8, Math.min(event.clientX + 10, window.innerWidth - bounds.width - 8))}px`;
      toast.style.top = `${Math.max(8, Math.min(event.clientY + 10, window.innerHeight - bounds.height - 8))}px`;
      requestAnimationFrame(() => toast.classList.add('is-visible'));
      window.setTimeout(() => toast.remove(), 800);
    });
  });
};

window.initializeMahjCoveShare = initializeMahjCoveShare;

const initializeCurrentShare = () => initializeMahjCoveShare(document);
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeCurrentShare, { once: true });
} else {
  initializeCurrentShare();
}
document.addEventListener('quick-add:loaded', (event) => {
  initializeMahjCoveShare(event.detail?.root || document);
});
